import { linkProjection, pageLinkProjection } from '../pages/common'

// Note: Using resolveReferences on header & footer results in way too many requests,
// hence the verbose query projection string.
export const headerAndFooterPreviewQueryProjection = `
  {
    'allSanityHeader': {
      "nodes": *[_type == "header"] {
        ...,
        mainNavigationNodes[] {
          ...,
          link {
            ${linkProjection}
          },
          subitems[] {
            ...,
            link {
              ${linkProjection}
            },
            subitems[] {
              ...,
              link {
                ${linkProjection}
              },
              subitems[] {
                ...,
                link {
                  ${linkProjection}
                },
                subitems[] {
                  ...,
                  link {
                    ${linkProjection}
                  },
                }
              }
            }
          }
        },
        pillLink1 {
          ${linkProjection}
        },
        pillLink2 {
          ${linkProjection}
        },
        secondaryNavigationNodes[] {
          link {
            ${linkProjection}
          }
        }
      }
    },
    'allSanityFooter': {
      "nodes": *[_type == "footer"] {
        ...,
        linkSections[] {
          ...,
          pageReference {
            ${pageLinkProjection}
          },
          subitems[] {
            _type == "link" => {
              ${linkProjection}
            },
            _type == "linkSubsection" => {
              ...,
              subitems[] {
                ${linkProjection}
              }
            }
          }
        }
      }
    }
  }
`
